import { fetchAPI } from '@quickbit/backoffice-core-frontend';
import { useState } from 'react';
import { useAsyncFn } from 'react-use';

interface ApiKeyOutput {
  apiKey: string;
}

const generateMerchantApiKey = async () =>
  await fetchAPI<ApiKeyOutput>(`v1/merchant/api-key `, {
    method: 'POST',
  });

const useApiKey = () => {
  const [apiKey, setApiKey] = useState<string | null>(null);
  const [{ loading }, onGenerateApiKey] = useAsyncFn(async () => {
    const { apiKey } = await generateMerchantApiKey();
    setApiKey(apiKey);
  }, []);

  const onClose = () => {
    setApiKey(null);
  };

  return { apiKey, loading, onGenerateApiKey, onClose };
};

export default useApiKey;
